
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function StickyHeader() {
    const elements = Array.from(document.querySelectorAll('.js-sticky-header'));

    elements.forEach(element => {
        ScrollTrigger.create({
            trigger: element,
            start: 'top top',
            endTrigger: 'html',
            end: 'bottom top',
            pin: true,
            anticipatePin: 1,
            toggleClass: 'sticky',
            onUpdate: ({ direction }) => {
                // console.log(progress, direction, getVelocity())

                if (direction === 1 && window.pageYOffset >= 5 * element.offsetHeight) {
                    // console.log('Sliding up')
                    element.classList.add('slide-up');

                } else {
                    element.classList.remove('slide-up');
                    // console.log('Removing slide up')
                }
            }
        });
    });
}
